var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-relative"},[_c('transition',{attrs:{"name":"slide"}},[_c('div',[_c('gl-head'),_c('div',{staticClass:"gl-mx-8 gl-my-9 gl-mt-6"},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }